import { createSelector, createSlice } from '@reduxjs/toolkit';

import { AppState } from '@/shared/redux/store/store';

type TBackgroundRefetchState = {
  isBackgroundMode: boolean;
};

const initialState: TBackgroundRefetchState = {
  isBackgroundMode: false,
};

const backgroundRefetchSlice = createSlice({
  name: 'backgroundRefetch',
  initialState,
  reducers: {
    setBackgroundMode: (state) => {
      state.isBackgroundMode = true;
    },
    clearBackgroundMode: (state) => {
      state.isBackgroundMode = false;
    },
  },
});

export const { setBackgroundMode, clearBackgroundMode } =
  backgroundRefetchSlice.actions;

export const backgroundRefetchReducer = backgroundRefetchSlice.reducer;

const selectBackgroundRefetchState = (state: AppState) =>
  state.backgroundRefetch;

export const selectIsBackgroundMode = createSelector(
  selectBackgroundRefetchState,
  (s) => s.isBackgroundMode,
);
